module.exports = __webpack_public_path__ + "static/media/pricing-icon-farmgate.5347c709.svg";